import {
    doc,
    getDoc,
    setDoc
} from "firebase/firestore";
import { db } from "../../firebase.config";


export const savePassportToFirestore = async (uid, passport) => {
    const userRef = doc(db, "users", uid);
    await setDoc(
        userRef,
        { passport },
        { merge: true}
    );
};

export const loadPassportFromFirestore = async (uid) => {
    const userRef = doc(db, "users", uid);
    const snapshot = await getDoc(userRef);
    if (!snapshot.exists()) {
        return null;
    }
    return snapshot.data().passport || null;
};